module.exports = __webpack_public_path__ + "img/patch-exclamation.9f03776e.svg";